import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useSettings, isAttendanceAvailable } from "@/lib/utils-app";
import { ClipboardCheck } from "lucide-react";

export default function AsistenciaProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const settings = useSettings();
  const attendanceOn = isAttendanceAvailable(settings);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="text-sm tracking-widest text-gray-400 uppercase">Cargando…</div>
      </div>
    );
  }

  if (!attendanceOn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4">
        <div className="glass-strong max-w-md w-full p-8 rounded-sm text-center">
          <ClipboardCheck className="mx-auto text-white/40 mb-4" size={48} />
          <h1 className="font-display text-2xl text-white">Módulo desactivado</h1>
          <p className="text-white/60 text-sm mt-2">
            Actívalo en Admin → Configuración → Asistencia.
          </p>
          <Link to="/admin/asistencia" className="btn-outline inline-block mt-6 text-sm">
            Volver al menú
          </Link>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;

  return children;
}
